import { API } from "../../legacy/api";
import { LegacyEvent } from "../../legacy/api";

export const handleEvent = func => {
  return e => {
    const APIName = e.currentTarget.getAttribute("data-api-name");
    const disabled = e.currentTarget.hasAttribute("disabled");

    if (disabled) {
      return;
    }

    // Notify framework of the event
    if (typeof APIName === "string" && APIName !== "") {
      const event = (APIName + "." + e.type) as LegacyEvent;
      API.notify(event, e);
    } else {
      console.warn(
        'Missing API name. Make sure the component utilizes the "data-api-name" attribute.',
        "Element:" + e.currentTarget
      );
    }

    // Call original onclick handler if exists
    if (typeof func === "function") {
      func(e);
    }
  };
};

export const preventEvent = (event: MouseEvent) => event.preventDefault();

export const isTouchSupported = (): boolean =>
  "ontouchstart" in window ||
  "ontouchstart" in document.documentElement ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;
